function iContains(baseString, searchString) {
	var lowerCasedBaseString = baseString.toLowerCase();
	var lowerCasedSearchString = searchString.toLowerCase();
	
	if(lowerCasedBaseString.indexOf(lowerCasedSearchString) > -1)
		return true;
	return false;
}

module.exports = iContains;